import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";


@Injectable({
  providedIn: "root",
})
export class TranslationService {
  private languageSubject = new Subject<string>();
  currentLanguage: string;

  constructor(private translate: TranslateService) {
  }

  translateTextEst(key: string): string {
    const currentLanguage = this.translate.currentLang;
    const targetLanguage = "et";
    if (currentLanguage === targetLanguage) {
      return this.translate.instant(key);
    } else {
      this.translate.use(targetLanguage);
      const translatedText = this.translate.instant(key);
      this.translate.use(currentLanguage);
      return translatedText;
    }
  }

  setLanguage(lang: string) {
    this.currentLanguage = lang;
    this.languageSubject.next(lang);
  }

  getLanguageObservable() {
    return this.languageSubject.asObservable();
  }

}
